import React from 'react';
import { withRouter } from '../../boot/hooks/useRouter';

import { MainButton, VideoContainer } from './Styles';

import I18n from '../../locales/i18n';

const HelpButton = ({ location, helpers = {} }) => {
	const { pathname } = location;
	let final_path = pathname.replace(/\//gi, '');
	if (pathname.startsWith('/event')) {
		const arrPath = pathname.split('/');
		final_path = arrPath[arrPath.length - 1];
	}

	final_path = final_path.replace(/-/gi, '_');

	const [ViewVideo, setViewVideo] = React.useState(false);
	const [isMaximized, setMaximized] = React.useState(false);

	if (helpers[final_path]) {
		return (
			<React.Fragment>
				<MainButton
					onClick={() => {
						setViewVideo(!ViewVideo);
					}}
				>
					<i className="fas fa-question" />
					<span>{I18n('MENU', 'VIDEO_HELPER')}</span>
				</MainButton>
				{ViewVideo && (
					<VideoContainer className={isMaximized ? 'maximized' : 'normal'}>
						<div className="header">
							<i
								className="fas fa-window-maximize"
								title="Maximizar"
								onClick={() => {
									setMaximized(!isMaximized);
								}}
							/>
							<i
								className="fas fa-times"
								title="Cerrar"
								onClick={() => {
									setViewVideo(false);
								}}
							/>
						</div>
						<div className="body">
							<iframe
								title={'Holi'}
								src={`https://www.youtube.com/embed/${helpers[final_path]}`}
								frameBorder="0"
								allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
								allowFullScreen
							></iframe>
						</div>
					</VideoContainer>
				)}
			</React.Fragment>
		);
	}

	return null;
};

export default withRouter(HelpButton);

//
